import React, { useEffect, useState } from "react";
import { Form } from "react-final-form";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { Row } from "reactstrap";
import useAutosave from "src/hooks/useAutosave";
import { IRootState } from "src/store/reducers";
import { appBuilderShouldSave } from "src/store/reducers/applicationBuilder";
import { fetchPremiumDetails, savePremiumDetails } from "src/store/reducers/applicationPremium";
import { TabProps } from "../../pages";
import DiscountsForm from "./Discounts/Discounts";
import PremiumForm from "./Premium/Premium";

export const AppPremiumDetail = (props: TabProps) => {
  const { id: applicationId } = useParams<{ id: string }>();
  const dispatch = useDispatch();
  const [formRef, setFormRef] = useState(null);

  const { userID, premiumDetails } = useSelector((state: IRootState) => ({
    userID: state.auth.user.userID,
    premiumDetails: state.applicationPremium.premiumDetails,
  }));

  useEffect(() => {
    dispatch(fetchPremiumDetails(applicationId));
  }, [dispatch, applicationId]);

  const performSave = async () => {
    dispatch(appBuilderShouldSave(false));

    if (!formRef) return;
    const state = formRef.getState();

    const payload = {
      ...state.values,
      createdBy: userID,
    };

    try {
      await dispatch(savePremiumDetails(applicationId, payload));
      await dispatch(fetchPremiumDetails(applicationId));
    } catch (error) {}
  };

  const AutoSave = useAutosave(props, performSave);

  return (
    <Form initialValues={premiumDetails} onSubmit={performSave}>
      {({ form, dirty }) => {
        if (!formRef) {
          setFormRef(form);
        }

        useEffect(() => {
          props.onDirty(dirty);
        }, [dirty]);

        return (
          <form onSubmit={form.submit}>
            <Row style={{ display: "flex", flexWrap: "nowrap" }}>
              <PremiumForm
                premiumMode={premiumDetails?.selectApplicationPremiumModeTypeList}
                policyTerm={premiumDetails?.selectApplicationPolicyTermTypeList}
              />
              <DiscountsForm />
            </Row>
            <AutoSave />
          </form>
        );
      }}
    </Form>
  );
};
